import { makeLink, makeUserContentLink } from '../../utils/linkbuilder';
import LinkPane from '../../components/linkpane';

const LINK_MSG:string="Link";

interface LinkWrapperProps{
	pageSelected:string,
	usermail:string,
	contentSelected:string[]
}

export const LinkWrapper=function(props:LinkWrapperProps){
	if(props.pageSelected==='')return null;
	if(props.contentSelected[1]==='user'&&props.usermail==='')return null;
	
	let myURL=makeLink(props.pageSelected,props.contentSelected);
	if(props.contentSelected[1]==='user'){
		myURL=makeUserContentLink(props.pageSelected,props.usermail,props.contentSelected[0]);
	}

	return(
		<div>
			<h3>{LINK_MSG}</h3>
			<LinkPane linkURL={myURL} />
		</div>
	)
}
